import { useState, useEffect } from 'react';
import { getCookie } from 'cookies-next';
import { DEFAULT_THEME } from '@constants/constants';
import navigationService from '@/services/navigation-service';
import type * as Types from '@/pages/mijn-carel-lurvink/catalogus/stores/types';

export const useCategories = () => {
  const [categories, setCategories] = useState<Types.Category[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        setLoading(true);
        setError(null);

        // Get the current sector/theme
        let theme = DEFAULT_THEME;
        try {
          const sectorCookie = getCookie('cl_sector') as string;
          theme = sectorCookie.toLowerCase();
        } catch {
          // Use default theme if cookie is not available
        }

        // Set the sector in the navigation service
        navigationService.setSector(theme as AppSector);

        // Fetch navigation data (categories)
        await navigationService.fetchNavigationData(undefined);

        // Get all categories
        const allCategories = navigationService.getAllCategories();
        setCategories(allCategories);
      } catch (err) {
        console.error('Error fetching categories:', err);
        setError(err instanceof Error ? err.message : 'Failed to fetch categories');
        setCategories([]);
      } finally {
        setLoading(false);
      }
    };

    fetchCategories();
  }, []);

  return { categories, loading, error };
};
